import React, {useState, useEffect} from 'react';
import {axiosInstance} from 'utils/auth.service';

import {useTranslation} from 'react-i18next';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';

const PaiementPostFinance = ({onClose, seance, keepOpen, coupon, customerInfos, onErreur}) => {
  const {t} = useTranslation();
  const [paymentPageUrl, setPaymentPageUrl] = useState(null);

  const currentUrl = window.location.href;

  useEffect(() => {
    const seanceId = seance.seance_id;
    const params = {
      url: currentUrl,
      customer: customerInfos,
      discount_code: null,
      failed_url: `${currentUrl}?paymentError`,
      success_url: `${currentUrl}?waitingPaymentConfirmation=postfinance`,
    };
    if (coupon) {
      params.discount_code = coupon.value;
    }

    axiosInstance
      .post(`/seances/${seanceId}/payment/postfinance`, params)
      .then(res => {
        setPaymentPageUrl(res.data.payment_page_url);
      })
      .catch(() => {
        onErreur(t('probleme-de-connexion-merci-dessayer-plus-tard'));
      });
  }, [seance, customerInfos, coupon, onErreur, t, currentUrl]);
  const proceed = () => {
    window.location.href = paymentPageUrl;
    setPaymentPageUrl(null);
  };
  return (
    <>
      <div className="spacer"></div>

      {Boolean(paymentPageUrl) ? (
        <>
          {!Boolean(keepOpen) && (
            <>
              <Button variant="outlined" color="primary" onClick={onClose}>
                {t('annuler')}
              </Button>{' '}
              &nbsp;
            </>
          )}
          <Button onClick={proceed} variant="contained" color="primary" disabled={false}>
            {t('continuer-vers-postfinance')}
          </Button>
        </>
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default PaiementPostFinance;
